const DonDonutsId = 1
const DonDonutsName = 'dondonuts'
const AlohaId = 6
const AlohaName = 'aloha'

const getNetId = () => {
  let netId = DonDonutsId

  const storedNetId = sessionStorage.getItem('netId')
  if (storedNetId) {
    netId = parseInt(storedNetId)
    if (isNaN(netId)) {
      netId = DonDonutsId
      sessionStorage.setItem('netId', netId.toString())
    }
  } else {
    let url = window.location.href

    if (/http.?\:\/\/qr\.aloha/.test(url)) {
      netId = 6
    } else if (/http.?\:\/\/qr\.don/.test(url)) {
      netId = 1
    }

    sessionStorage.setItem('netId', netId.toString())
  }

  return netId
}

const getNetName = () => {
  let netName = DonDonutsName

  let netId = getNetId()

  switch (netId) {
    case DonDonutsId:
      netName = DonDonutsName
      break
    case AlohaId:
      netName = AlohaName
      break
  }

  return netName
}

const isDonDonuts = () => {
  return getNetId() === DonDonutsId
}

const isAloha = () => {
  return getNetId() === AlohaId
}

export {
  DonDonutsId,
  DonDonutsName,
  isDonDonuts,
  AlohaId,
  AlohaName,
  isAloha,
  getNetId,
  getNetName,
}
